// extracted by mini-css-extract-plugin
module.exports = {"numeric-input":"NumericInput_numeric-input__1BMWV","no-margin":"NumericInput_no-margin__u_Bku","strike":"NumericInput_strike__3GiVu","input":"NumericInput_input__3YXfw"};